import {IPoint} from "../interfaces/IPoint";

export class PointUtils {

    static equals(p1: IPoint, p2: IPoint) {
        return (p1.lat === p2.lat && p1.lon === p2.lon);
    }

}
